import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange
}: PaginationProps) => {
  const pages = Array.from({
    length: totalPages
  }, (_, i) => i + 1);
  // Show max 5 pages with ellipsis
  const getVisiblePages = () => {
    if (totalPages <= 5) return pages;
    if (currentPage <= 3) {
      return [...pages.slice(0, 5), '...', totalPages];
    } else if (currentPage >= totalPages - 2) {
      return [1, '...', ...pages.slice(totalPages - 5)];
    } else {
      return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
    }
  };
  const visiblePages = getVisiblePages();
  return <div className="flex items-center justify-center space-x-2" data-id="element-167">
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="inline-flex items-center px-2 py-2 rounded-md border border-border bg-surface text-sm font-medium text-text-muted hover:bg-background disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Previous page" data-id="element-168">
        <span className="sr-only" data-id="element-169">Previous</span>
        <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-170" />
      </button>
      <div className="flex space-x-2" data-id="element-171">
        {visiblePages.map((page, index) => {
        if (page === '...') {
          return <span key={`ellipsis-${index}`} className="inline-flex items-center px-4 py-2 text-sm text-text-muted" data-id="element-172">
                ...
              </span>;
        }
        return <button key={page} onClick={() => onPageChange(page as number)} className={`inline-flex items-center px-4 py-2 rounded-md border text-sm font-medium transition-colors ${currentPage === page ? 'z-10 bg-primary border-primary text-white' : 'bg-surface border-border text-text-main hover:bg-background'}`} aria-current={currentPage === page ? 'page' : undefined} data-id="element-173">
              {page}
            </button>;
      })}
      </div>
      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="inline-flex items-center px-2 py-2 rounded-md border border-border bg-surface text-sm font-medium text-text-muted hover:bg-background disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Next page" data-id="element-174">
        <span className="sr-only" data-id="element-175">Next</span>
        <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-176" />
      </button>
    </div>;
};
export default Pagination;